import * as CookieConsent from "vanilla-cookieconsent";

const initCookieConsent = () => {

    CookieConsent.run({

        guiOptions: {
            consentModal: {
                layout: 'box inline',
                position: 'bottom right',
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: 'box',
                equalWeightButtons: true,
                flipButtons: false
            }
        },

        categories: {
            necessary: {
                enabled: true,  // this category is enabled by default
                readOnly: true  // this category cannot be disabled
            },
            analytics: {}
        },

        language: {
            default: 'en',
            translations: {
                'en': '/wp-content/themes/assemblics/dist/translations/cookieConsent-en.json'
            }
        }
    });

}

export { initCookieConsent }